"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ComponentPropsWithoutRef, MouseEvent } from "react";
import { useCallback, useState } from "react";
type NextLinkProps = ComponentPropsWithoutRef<typeof Link>;
export function HoverPrefetchLink(t0) {
  const $ = _c(9);
  let onMouseEnter;
  let props;
  if ($[0] !== t0) {
    ({
      onMouseEnter,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onMouseEnter;
    $[2] = props;
  } else {
    onMouseEnter = $[1];
    props = $[2];
  }
  const [active, setActive] = useState(false);
  let t1;
  if ($[3] !== onMouseEnter) {
    t1 = event => {
      setActive(true);
      onMouseEnter?.(event);
    };
    $[3] = onMouseEnter;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleMouseEnter = t1;
  const t2 = active ? null : false;
  let t3;
  if ($[5] !== handleMouseEnter || $[6] !== props || $[7] !== t2) {
    t3 = <Link prefetch={t2} onMouseEnter={handleMouseEnter} {...props} />;
    $[5] = handleMouseEnter;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}